import React from 'react';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import TextField from '@material-ui/core/TextField';
import Switch from '@material-ui/core/Switch';
import Typography from '@material-ui/core/Typography';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';

import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';

import { GlobalContext } from '../../Context/Global.context';
import ProgressIndicator from '../../Components/ProgressIndicator';

import API from '../../Util/api';
import debounce from 'es6-promise-debounce';
import { IsMobile } from '../../Util/MobileDetector';

import {
  GetOrganizationGroupPathForApi,
  GetOrganizationMembersPathForApi,
  GetOrganizationGroupMembersPathForApi,
} from '../../Util/api';

const styles = theme => ({
  dialogPaper: {
    height:(!IsMobile()) ? "80%" : undefined,
  },
  dialogTitle: {
  },
  dialogContent: {
    display: "flex",
    flexDirection: "column",
  },
  dialogActions: {
  },
  contentContainer: {
    marginTop:theme.spacing(2),
    flex: 1,
    minHeight: 0,
    display: "flex",
    flexDirection: "column",
    "& .MuiListItem-gutters": {
      paddingLeft: 0,
    },
  },
  membersList: {
    flex: 1,
    minHeight: 0,
    overflow: 'auto',
  },
});

class OrganizationGroupDialog extends React.Component {
  static contextType = GlobalContext;

  constructor(props) {
    super(props);

    this.state = {
      open: props.open,
      OrganizationGroup: props.OrganizationGroup,
      ShowProgressIndicator: false,
      organizationMembers: [],
      organizationGroupMembers: [],
      nameValue: props.OrganizationGroup ? props.OrganizationGroup.Name : '',
    }
  }

  handleClose = () => {
    this.setState({
      open: false,
    });
    if (this.props.onClose) {
      this.props.onClose();
    }
  }

  updateOrganizationGroup = OrganizationGroup => {
    this.setState({OrganizationGroup});
    this.handleUpdateServerOrganizationGroup(OrganizationGroup);
    if (OrganizationGroup && this.props.onOrganizationGroupRevised) {
      this.props.onOrganizationGroupRevised({...OrganizationGroup});
    }
  }

  handleUpdateServerOrganizationGroup = debounce(organizationGroup => {
    if (!this.props.OrganizationGroup) {
      return;
    }
    if (!organizationGroup) {
      organizationGroup = {...this.state.OrganizationGroup};
    }

    API.put(GetOrganizationGroupPathForApi(organizationGroup.OrganizationID, organizationGroup.ID),
      organizationGroup)
      .then(resp => {
      })
      .catch(this.handleApiError);
  }, 250);

  handleNameChange = (event) => {
    const nameValue = event.target.value;
    this.setState({ nameValue });

    // Update the organization group with the new name
    const updatedOrganizationGroup = { ...this.state.OrganizationGroup, Name: nameValue };
    this.updateOrganizationGroup(updatedOrganizationGroup);
  }

  handleToggleMember = (organizationMemberId, memberEmail) => {
    const { organizationGroupMembers, OrganizationGroup } = this.state;

    // Check if member is already in the group
    const organizationGroupMember = organizationGroupMembers.find(m => m.UserEmail === memberEmail);
    const isMemberInGroup = Boolean(organizationGroupMember);

    if (isMemberInGroup) {
      // Remove member from group
      this.setState({ ShowProgressIndicator: true });
      API.delete(GetOrganizationGroupMembersPathForApi(OrganizationGroup.OrganizationID, OrganizationGroup.ID),
        { data: { IDs: [organizationGroupMember.ID] } })
        .then(() => {
          // Update the list of members in the group
          this.loadOrganizationGroupMembers();
        })
        .catch(this.handleApiError);
    } else {
      // Add member to group
      this.setState({ ShowProgressIndicator: true });
      API.post(GetOrganizationGroupMembersPathForApi(OrganizationGroup.OrganizationID, OrganizationGroup.ID),
        [{ OrganizationMemberID: organizationMemberId }])
        .then(() => {
          // Update the list of members in the group
          this.loadOrganizationGroupMembers();
        })
        .catch(this.handleApiError);
    }
  }

  loadOrganizationMembers = () => {
    const { OrganizationGroup } = this.state;
    if (!OrganizationGroup) return;

    this.setState({ ShowProgressIndicator: true });
    // The members endpoint pages by cursor and may return a cursor even on its final
    // page (which then repeats members), so dedupe by ID and stop when a page adds nothing new.
    const organizationMembers = [];
    const seenIds = {};
    const getPage = cursor => {
      return API.get(GetOrganizationMembersPathForApi(OrganizationGroup.OrganizationID),
        { params: { cursor } })
        .then(resp => {
          const pageMembers = resp.data.OrganizationMembers || [];
          let added = 0;
          pageMembers.forEach(m => {
            if (!seenIds[m.ID]) {
              seenIds[m.ID] = true;
              organizationMembers.push(m);
              added++;
            }
          });
          if (added > 0 && resp.data.Cursor && resp.data.Cursor !== cursor) {
            return getPage(resp.data.Cursor);
          }
          return organizationMembers;
        });
    };
    getPage("")
      .then(allMembers => {
        this.setState({
          organizationMembers: allMembers,
          ShowProgressIndicator: false,
        });
      })
      .catch(this.handleApiError);
  }

  loadOrganizationGroupMembers = () => {
    const { OrganizationGroup } = this.state;
    if (!OrganizationGroup) return;

    this.setState({ ShowProgressIndicator: true });
    API.get(GetOrganizationGroupMembersPathForApi(OrganizationGroup.OrganizationID, OrganizationGroup.ID),
      { params: { getAll: true } })
      .then(resp => {
        this.setState({
          organizationGroupMembers: resp.data.OrganizationGroupMembers || [],
          ShowProgressIndicator: false,
        });
      })
      .catch(this.handleApiError);
  }

  handleApiError = err => {
    this.setState({ShowProgressIndicator: false});
    this.props.onApiError(err);
  }

  componentDidMount() {
    if (this.state.OrganizationGroup) {
      this.loadOrganizationMembers();
      this.loadOrganizationGroupMembers();
    }
  }

  componentDidUpdate(prevProps) {
    if (typeof this.props.open !== "undefined"
      && prevProps.open !== this.props.open) {
      let stateToUpdate = {
        open: this.props.open !== false,
      }
      if (this.props.open) {
        if (this.props.OrganizationGroup) {
          stateToUpdate.OrganizationGroup = this.props.OrganizationGroup;
          stateToUpdate.nameValue = this.props.OrganizationGroup.Name;

          // Load members when dialog opens with an organization group
          this.setState(stateToUpdate, () => {
            this.loadOrganizationMembers();
            this.loadOrganizationGroupMembers();
          });
          return;
        } else {
          stateToUpdate.OrganizationGroup = null;
        }
      } else {
        stateToUpdate.OrganizationGroup = null;
      }
      this.setState(stateToUpdate);
    }
  }

  render() {
    const {
      open,
      OrganizationGroup,
      ShowProgressIndicator,
      nameValue,
      organizationMembers,
      organizationGroupMembers,
    } = this.state;
    const {
      classes,
      theme,
      showProgressIndicatorImmediately,
    } = this.props;
    const {
      CompletedGET,
    } = this.context;

    if (!CompletedGET.UserPreferences) {
      return null;
    }

    const dialogActions = (
      <DialogActions className={classes.dialogActions}>
        <Button onClick={() => this.handleClose()}>
          CLOSE
        </Button>
      </DialogActions>
    );

    const progressIndicator = (ShowProgressIndicator || showProgressIndicatorImmediately)
      ? (
        <ProgressIndicator showImmediately={showProgressIndicatorImmediately} />
      )
      : null;

    const content = OrganizationGroup ? (
      <React.Fragment>
        <Grid container direction="column" wrap="nowrap" spacing={2} style={{flex:1, minHeight:0}}>
          <Grid item>
            <TextField
              fullWidth
              label="Group Name"
              variant="outlined"
              value={nameValue}
              onChange={this.handleNameChange}
            />
          </Grid>

          <Grid item style={{marginLeft:theme.spacing(1),marginRight:theme.spacing(1),marginTop:theme.spacing(1),flex:1,minHeight:0,display:"flex",flexDirection:"column"}}>
            <Grid container>
              <Grid item xs={6}>
                <Typography variant="subtitle2">Member</Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="subtitle2" align="right">In Group</Typography>
              </Grid>
            </Grid>
            <List className={classes.membersList}>
              {organizationMembers.map(member => {
                const isInGroup = organizationGroupMembers.some(m => m.UserEmail === member.UserEmail);
                return (
                  <ListItem key={member.ID}>
                    <ListItemText primary={member.UserEmail} />
                    <ListItemSecondaryAction style={{right:0}}>
                      <Switch
                        checked={isInGroup}
                        onChange={() => this.handleToggleMember(member.ID, member.UserEmail)}
                        color="primary"
                      />
                    </ListItemSecondaryAction>
                  </ListItem>
                );
              })}
            </List>
          </Grid>
        </Grid>
      </React.Fragment>
    ) : null;

    return (
      <Dialog
        fullScreen={IsMobile()}
        fullWidth={!IsMobile()}
        maxWidth="sm"
        open={open}
        classes={{
          paper:classes.dialogPaper,
        }}
        onClose={() => this.handleClose()}
      >
        <DialogTitle id="dialog-title" className={classes.dialogTitle}>
          Organization Group Details
        </DialogTitle>
        <DialogContent className={classes.dialogContent}>
          {progressIndicator}

          <div className={classes.contentContainer}>
            {content}
          </div>

        </DialogContent>
        {dialogActions}
      </Dialog>
    );
  }
}

OrganizationGroupDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  OrganizationGroup: PropTypes.object,
  onClose: PropTypes.func,
  onApiError: PropTypes.func.isRequired,
  onOrganizationGroupRevised: PropTypes.func,
};

export default withStyles(styles, {withTheme: true})(OrganizationGroupDialog);
